import { NewReleases } from "@mui/icons-material";
import Badge from "@mui/material/Badge";
import React from "react";
import { Link } from "react-router-dom";
import { StyledListSubItem } from "../../styled/layout";
import DrawerItemTooltip from "./drawerItemTooltip";

const ListSubItemComponent = ({
  path,
  selected,
  title,
  title2 = "",
  icon,
  open,
  id,
  isNew,
  notification,
}) => {
  return (
    <DrawerItemTooltip drawerOpen={open} tooltipText={title + " " + title2}>
      <StyledListSubItem.List
        component="div"
        disablePadding
        itemSelected={selected}
        open={open}>
        <StyledListSubItem.Nested
          button
          component={Link}
          selected={selected}
          to={path}
          id={id}>
          <StyledListSubItem.ListIcon itemSelected={selected}>
            {icon}
          </StyledListSubItem.ListIcon>
          {open && (
            <StyledListSubItem.TitleContainer>
              <StyledListSubItem.Text itemSelected={selected}>
                {title}
              </StyledListSubItem.Text>
              <StyledListSubItem.Text itemSelected={selected}>
                {title2}
              </StyledListSubItem.Text>
            </StyledListSubItem.TitleContainer>
          )}
          {isNew && (
            <StyledListSubItem.RightIcon itemSelected={selected}>
              <NewReleases />
            </StyledListSubItem.RightIcon>
          )}
          {notification > 0 && (
            <StyledListSubItem.RightIcon itemSelected={selected}>
              <Badge badgeContent={notification} color="primary" />
            </StyledListSubItem.RightIcon>
          )}
        </StyledListSubItem.Nested>
      </StyledListSubItem.List>
    </DrawerItemTooltip>
  );
};

export default ListSubItemComponent;
